"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var I18n = require("i18n-js");
var lodash_1 = require("lodash");
var sanitized_render_1 = require("../components/sanitized_render");
var rql_1 = require("../rql");
var url_helpers_1 = require("../url_helpers");
function hasExpeditedShipping(listing) {
    var shippingPrices = lodash_1.get(listing, 'shipping.shippingPrices') || [];
    var expeditedShipping = shippingPrices.filter(function (price) {
        return price.shippingMethod === rql_1.core_apimessages_ShippingMethod.EXPEDITED_SHIPPING;
    });
    return expeditedShipping.length > 0;
}
function CombinedSaleAndShippingNotice(props) {
    if (!hasExpeditedShipping(props.listing) && !lodash_1.get(props.listing, 'sale.id')) {
        return null;
    }
    if (!hasExpeditedShipping(props.listing) && lodash_1.get(props.listing, 'sale.id')) {
        return (React.createElement("p", { className: "offers-form__notice offers-form__notice--sale" }, I18n.t('commons.offers.saleNotice')));
    }
    if (hasExpeditedShipping(props.listing) && !lodash_1.get(props.listing, 'sale.id')) {
        return (React.createElement("p", { className: "offers-form__notice offers-form__notice--shipping" }, I18n.t('commons.offers.freeTwoDayShippingNotice')));
    }
    return (React.createElement("p", { className: "offers-form__notice offers-form__notice--sale" }, I18n.t('commons.offers.combinedSaleShippingNotice')));
}
exports.CombinedSaleAndShippingNotice = CombinedSaleAndShippingNotice;
function TimelineNotice(props) {
    var shopName = lodash_1.get(props, 'shop.name');
    if (!shopName) {
        return null;
    }
    return (React.createElement("p", { className: "offers-form__notice offers-form__notice--time" }, I18n.t('commons.offers.timeline', { shopName: shopName })));
}
exports.TimelineNotice = TimelineNotice;
function SalesTaxNotice(props) {
    var slug = lodash_1.get(props, 'shop.slug');
    return (React.createElement("p", { className: "offers-form__notice offers-form__notice--tax" },
        React.createElement(sanitized_render_1.default, { html: I18n.t('commons.offers.salesTaxMayBeApplied', {
                linkOpen: "<a href=\"" + url_helpers_1.SHOP_PATH.expand({ slug: slug }) + "/about\" target=\"_blank\">",
                linkClose: '</a>',
            }) })));
}
exports.SalesTaxNotice = SalesTaxNotice;
//# sourceMappingURL=offer_notices.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/offers/offer_notices.js
// module id = GA/6
// module chunks = 20 21